import { render, staticRenderFns } from "./MultiSelectButton.vue?vue&type=template&id=6a1bb6e2&lang=pug&"
import script from "./MultiSelectButton.vue?vue&type=script&lang=js&"
export * from "./MultiSelectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports